import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";
import { ViewButton } from "@components";

export const SoftwareInventoryTableColumn = (
  t: TFunction<"translation", undefined>,
) => {
  return [
    {
      id: 1,
      key: "softwareName",
      name: t("SOFTWARE_INVENTORY.TABLE.COLUMN.SOFTWARE_NAME"),
      render: (softwareName: string) => {
        return (
          <>
            <Text className="text-nowrap text-info" component="p">
              {softwareName}
            </Text>
          </>
        );
      },
    },
    {
      id: 2,
      key: "supplierName",
      name: t("SOFTWARE_INVENTORY.TABLE.COLUMN.SUPPLIER_NAME"),
      render: (supplierName: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {supplierName}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "price",
      name: t("SOFTWARE_INVENTORY.TABLE.COLUMN.PRICE"),
      render: (price: number) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {price}
          </Text>
        );
      },
    },
    {
      id: 4,
      key: "purchaseDate",
      name: t("SOFTWARE_INVENTORY.TABLE.COLUMN.PURCHASE_DATE_GO_LIVE_DATE"),
      render: (purchaseDate: string, row: any) => {
        return (
          <Text color="subtitle2" className="text-nowrap" component="p">
            {purchaseDate} ~{" "}
            <span className="text-warning">{row.goLiveDate}</span>
          </Text>
        );
      },
    },
    {
      id: 5,
      key: "licenseRenewalDate",
      name: t("SOFTWARE_INVENTORY.TABLE.COLUMN.LICENSE_RENEWAL_DATE"),
      render: (licenseRenewalDate: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {licenseRenewalDate}
          </Text>
        );
      },
    },
    {
      id: 6,
      key: "warrantyPeriod",
      name: t("SOFTWARE_INVENTORY.TABLE.COLUMN.WARRANTY_PERIOD"),
      render: (WarrantyPeriod: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {WarrantyPeriod}
          </Text>
        );
      },
    },
    {
      id: 7,
      key: "warrantyExpiryDate",
      name: t("SOFTWARE_INVENTORY.TABLE.COLUMN.WARRANTY_EXPIRE_DATE"),
      render: (WarrantyExpiryDate: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {WarrantyExpiryDate}
          </Text>
        );
      },
    },
    {
      id: 8,
      key: "partyName",
      name: t("SOFTWARE_INVENTORY.TABLE.COLUMN.MAINTENANCE_PARTY_NAME"),
      render: (partyName: string, row: any) => {
        return (
          <>
            <Text color="subtitle2" className="text-nowrap" component="p">
              {partyName ? partyName : "---"}
            </Text>

            <Text color="subtitle2" className="text-nowrap" component="p">
              {row?.maintenanceContactExpiryDate
                ? row?.maintenanceContactExpiryDate
                : "---"}
            </Text>
          </>
        );
      },
    },
    {
      id: 9,
      key: "id",
      name: "",
      render: (id: string | number) => {
        return (
          <ViewButton
            label="SOFTWARE_INVENTORY.TABLE.DETAILS_BUTTON_TEXT"
            link={id.toString()}
          />
        );
      },
    },
  ];
};
